import React from "react";
import { Outlet } from "react-router-dom";
import Heading from "./Heading";
import Footer from "./Footer";

const Layout = () => (
  <div className="flex flex-col min-h-screen bg-white text-gray-900 dark:bg-gray-900 dark:text-white">
    <header className="bg-gray-100 shadow relative z-10">
      <Heading />
    </header>
    <main className="flex-grow bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <Outlet />
      </div>
    </main>
    <Footer />
  </div>
);

export default Layout;
